import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import useLogout from "../../hooks/useLogout";
import { useFieldArray, useForm } from "react-hook-form";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Form, Spinner } from "reactstrap";
import MyInput from "../../MyComp/UI/form/MyInput";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import MyGST from "../../MyComp/UI/form/MyGST";
import moment from "moment";
import DateComponent from "../../MyComp/UI/form/DateComponent";
import { getLabDetailsAPI, labApprovalAPI } from "../../api/lab";
import { toast } from "react-toastify";
import { getZipDetailsAPI } from "../../api/master/indes";
import { BASE_URL_IMG } from "../../assets/constants";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import MyEmail from "../../MyComp/UI/form/MyEmail";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

// CSS for red border styling
const objectionStyles = `
  .objection-field {
    position: relative;
  }
  
  .objection-field input,
  .objection-field select,
  .objection-field textarea,
  .objection-field .form-control,
  .objection-field .react-select__control,
  .objection-field .css-13cymwt-control,
  .objection-field .css-t3ipsp-control,
  .objection-field .input-group,
  .objection-field .form-control:focus {
    border: 2px solid #ff0000 !important;
    box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.1) !important;
  }
  
  .objection-field label,
  .objection-field .form-label {
    color: #ff0000 !important;
    font-weight: 600 !important;
  }
  
  /* For image upload components */
  .objection-image-upload {
    border: 2px solid #ff0000 !important;
    border-radius: 4px !important;
    padding: 5px !important;
    display: inline-block;
  }
  
  /* Error message styling */
  .objection-error-message {
    color: #ff0000;
    font-size: 12px;
    margin-top: 5px;
    font-weight: 500;
  }
`;

const LabDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      qualificationDD: [],
      specializationDD: [],

      objectionKeys: [],
      approvedKeys: [],

      pan_image: null,
      pan: null,

      nabl_certificate: null,
      nabl_certificate_img: null,

      nabh_certificate: null,
      nabh_certificate_img: null,

      other_certificate: null,
      other_certificate_img: null,

      lab_license: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],

      passbook: null,
      passbook_image: null,

      lab: [
        {
          image: null,
          image_url: null,
        },
      ],
      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "lab_license",
  });

  const {
    fields: labFields,
    append: labAppend,
    remove: labRemove,
  } = useFieldArray({
    control,
    name: "lab",
  });

  const userRole = localStorage.getItem("role");
  console.log("User Role:", userRole); // Debug: Check the user role value
  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const doctorId = location?.state?.doctorId || "";
  const queryParams = new URLSearchParams(location.search);
  const labId = queryParams.get("labId");
  const isLoading = watch("isLoading");
  const [data, setData] = useState({});

  // Function to check if a field is in objection keys (supports nested and array fields)
  const isFieldObjection = (fieldName, index = null) => {
    if (!data || !data.keys || !Array.isArray(data.keys)) {
      return false;
    }

    // Check exact match
    if (data.keys.includes(fieldName)) {
      return true;
    }

    // Check with array index pattern (e.g., "license_documents[0]" or "lab_images[1]")
    if (index !== null && index !== undefined) {
      const arrayFieldName = `${fieldName}[${index}]`;
      if (data.keys.includes(arrayFieldName)) {
        return true;
      }

      // Also check for nested object patterns
      const nestedFieldName = `${fieldName}.${index}`;
      if (data.keys.includes(nestedFieldName)) {
        return true;
      }
    }

    // Check for partial matches (for nested fields)
    for (const key of data.keys) {
      if (key.includes(fieldName) || fieldName.includes(key)) {
        return true;
      }
    }

    return false;
  };

  // Function to get dynamic class names for objection fields
  const getFieldClassName = (fieldName, index = null, baseClass = "mt-2") => {
    const isObjection = isFieldObjection(fieldName, index);
    return `${baseClass} ${isObjection ? 'objection-field' : ''}`;
  };

  // Function to get objection prop for child components
  const getObjectionProp = (fieldName, index = null) => {
    return isFieldObjection(fieldName, index);
  };

  const [imageOpen, setImageOpen] = useState(false);

  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };

  useEffect(() => {
    getLabDetail();
  }, []);

  function parseTimeToDate(timeString) {
    const date = new Date();

    if (/AM|PM/i.test(timeString)) {
      const [time, modifier] = timeString.split(/ (AM|PM)/i);
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier.toUpperCase() === "PM" && hours < 12) {
        hours += 12;
      }
      if (modifier.toUpperCase() === "AM" && hours === 12) {
        hours = 0;
      }

      date.setHours(hours);
      date.setMinutes(minutes);
    } else {
      const [hours, minutes] = timeString.split(":").map(Number);
      date.setHours(hours);
      date.setMinutes(minutes);
    }

    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  const getLabDetail = () => {
    const body = {
      labId: labId,
    };
    getLabDetailsAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const lab = res.data.data;
          toast.clearWaitingQueue();
          console.log("data", lab);
          console.log("Objection Keys:", lab.keys); // Debug: See which keys are rejected
          setData(lab);

          //!Step one form details
          setValue("name", lab?.name || "");
          setValue("mobile", lab?.mobile || "");
          setValue("contact_number", lab?.contact_number || "");
          setValue("alt_contact_number", lab?.alt_contact_number || "");
          setValue("pincode", lab?.pincode || "");
          trigger("pincode");
          setValue("address", lab?.address || "");
          setValue("person_name", lab?.person_name || "");
          setValue("latitude", lab.latitude);
          setValue("longitude", lab.longitude);
          setValue("map_link", lab?.map_link || "");
          setValue("lab_type", lab?.lab_type || "");
          setValue("email", lab.email || "");
          setValue("address", lab.address);

          //!step two details
          setValue("nablId", lab?.nablId || "");
          setValue("nabhId", lab?.nabhId || "");
          setValue("otherIds", lab?.otherIds || "");
          setValue("gstNumber", lab?.gst_number || "");
          setValue("licenseNumber", lab?.license_no || "");

          if (lab?.nablEndDate) {
            const dob = moment(
              lab?.nablEndDate,
              ["DD/MM/YYYY", "YYYY-MM-DD"],
              true
            );

            if (dob.isValid()) {
              setValue("nablEndDate", dob.toDate());
            }
          }
          if (lab?.nabhEndDate) {
            const dob = moment(
              lab?.nabhEndDate,
              ["DD/MM/YYYY", "YYYY-MM-DD"],
              true
            );

            if (dob.isValid()) {
              setValue("nabhEndDate", dob.toDate());
            }
          }
          if (lab?.otherEndDate) {
            const dob = moment(
              lab?.otherEndDate,
              ["DD/MM/YYYY", "YYYY-MM-DD"],
              true
            );

            if (dob.isValid()) {
              setValue("otherEndDate", dob.toDate());
            }
          }
          setValue("isNablCertified", lab.nabl_certified);
          setValue("nablId", lab.nablId);
          setValue("nabl_certificate_img", `${BASE_URL_IMG}${lab.nabl_certificate}`);
          setValue("cmo_image", `${BASE_URL_IMG}${lab.cmo_certificate}`);
          setValue("cmo_certificate", `${BASE_URL_IMG}${lab.cmo_certificate}`);
          setValue("cmoNumber", lab.cmoCertificateNumber);
          setValue("nabl_certificate", lab?.nabl_certificate ? `${BASE_URL_IMG}${lab?.nabl_certificate}` : null);
          setValue("nabh_certificate", lab?.nabh_certificate ? `${BASE_URL_IMG}${lab?.nabh_certificate}` : null);
          setValue("other_certificate", lab?.other_certificate ? `${BASE_URL_IMG}${lab?.other_certificate}` : null);

          if (lab.license_documents && Array.isArray(lab.license_documents)) {
            remove();
            lab?.license_documents?.forEach((item) => {
              append({
                certificate: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
                certificate_url: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
              });
            });
          }

          //! step 3 details
          setValue("service_pincode", lab?.labservices?.pincode || "");
          setValue("radius", lab?.labservices?.radius || "");
          setValue("service", lab?.labservices?.service || "");
          const sTime24 = lab?.labservices?.startTime;
          const parsedTime = sTime24 ? parseTimeToDate(sTime24) : null;
          const eTime24 = lab?.labservices?.endTime;
          const parsedETime = eTime24 ? parseTimeToDate(eTime24) : null;
          setValue("startTime", lab?.labservices?.startTime ? new Date(parsedTime) : null);
          setValue("endTime", lab?.labservices?.endTime ? new Date(parsedETime) : null);

          //! step 4 details
          setValue("bankName", lab?.bankName || "");
          setValue("accountNumber", lab?.accountNumber || "");
          setValue("ifscCode", lab?.ifscCode || "");
          setValue("pan_image", `${BASE_URL_IMG}${lab.pan}`);
          setValue("upiId", lab?.upiId || "");
          setValue("passbook_image", lab.passbook ? `${BASE_URL_IMG}${lab.passbook}` : null);

          if (lab.lab_images && Array.isArray(lab.lab_images)) {
            labRemove();
            lab?.lab_images?.forEach((item) => {
              labAppend({
                image: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
                image_url: item?.url ? `${BASE_URL_IMG}${item.url}` : null,
              });
            });
          }

          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (watch("pincode") && watch("pincode").toString().length === 6) {
      const body = {
        pin_code: watch("pincode"),
      };
      getZipDetails(body);
    }
  }, [watch("pincode")]);

  const getZipDetails = (body) => {
    getZipDetailsAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          const responseData = res.data.data[0];
          console.log("zip details", responseData);
          setValue("city", responseData.district_name);
          setValue("state", responseData.state_name);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const onFormSubmit = (data) => {
    if (mode === "Approval") {
      const actionType = watch("actionType");

      const body = {
        remark: watch("remark") || "",
        keys: watch("objectionKeys")?.map((item) => item) || [],
        labId: labId || "",
        actionType: actionType,
      };

      labApprovalAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            navigate("/lab");
            toast.success(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === false) {
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
        });
    }
  };

  const [fieldConfirmOpen, setFieldConfirmOpen] = useState(false);
  const [fieldConfirmKey, setFieldConfirmKey] = useState("");
  const [fieldConfirmLabel, setFieldConfirmLabel] = useState("");

  const openFieldConfirmModal = (fieldKey, label) => {
    setFieldConfirmKey(fieldKey);
    setFieldConfirmLabel(label);
    setFieldConfirmOpen(true);
  };

  const closeFieldConfirmModal = () => {
    setFieldConfirmOpen(false);
    setFieldConfirmKey("");
    setFieldConfirmLabel("");
  };

  const handleFieldConfirmAction = (action) => {
    const objectionKeys = watch("objectionKeys") || [];
    let updatedKeys = [...objectionKeys];

    if (action === "reject") {
      if (fieldConfirmKey && !updatedKeys.includes(fieldConfirmKey)) {
        updatedKeys.push(fieldConfirmKey);
      }
    }

    if (action === "approve") {
      updatedKeys = updatedKeys.filter((key) => key !== fieldConfirmKey);
    }

    setValue("objectionKeys", updatedKeys);
    trigger("objectionKeys");
    closeFieldConfirmModal();
  };
  const FieldWithReject = ({ fieldKey, children }) => {
    const objectionKeys = watch("objectionKeys") || [];
    const isRejected = fieldKey && objectionKeys.includes(fieldKey);

    return (
      <div className="form-group">
        <div className="d-flex align-items-end">
          <div className="flex-grow-1">{children}</div>
          {mode === "Approval" && fieldKey && (
            <Button
              type="button"
              size="sm"
              color={isRejected ? "danger" : "warning"}
              outline
              className="ms-2 mb-1"
              onClick={() => openFieldConfirmModal(fieldKey, fieldKey)}
            >
              {isRejected ? "Rejected" : "Reject"}
            </Button>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <Head title="Laboratory Details" />
      <Content>
        <style>{objectionStyles}</style>

        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Laboratory"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                {/* <Button
                  color="primary"
                  outline
                  className={`me-n1`}
                  onClick={() => {
                    navigate("/lab");
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button> */}
                <div>
                  <Button
                    color="primary"
                    outline
                    className="me-n1"
                    onClick={() => {                    
                      if (userRole === "lab") {
                        navigate("/individual-lab");
                      } else if (userRole === "admin") {
                        navigate("/lab");
                      } 
                    }}
                  >
                    <Icon name="arrow-left" />
                  </Button>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {/* Display rejected keys for debugging */}
        {data?.keys && data.keys.length > 0 && (
          <div className="alert alert-danger mb-3">
            <strong>Rejected Fields:</strong> {data.keys.join(", ")}
          </div>
        )}

        <Block>
          <PreviewAltCard>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row className=" ">
                <div className="d-flex gap-5 py-3 mb-3">
                  <h5>{"Lab & Diagnostics Profile"}</h5>
                  <hr />
                </div>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("name")}>
                  {/* <FieldWithReject fieldKey="name"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Lab Name"
                    name="name"
                    placeholder="Enter your store full name"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("name")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("lab_type")}>
                  {/* <FieldWithReject fieldKey="lab_type"> */}
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Lab Type"}
                    name={"lab_type"}
                    placeholder={"diagnostic center"}
                    multi
                    options={watch("labTypeDD")}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("lab_type")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("pincode")}>
                  {/* <FieldWithReject fieldKey="pincode"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Pin Code"}
                    name={"pincode"}
                    placeholder={"Enter pin code"}
                    min={6}
                    max={6}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("pincode")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("state")}>
                  {/* <FieldWithReject fieldKey="state"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"State"}
                    name={"state"}
                    placeholder={"Select state"}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("state")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("city")}>
                  {/* <FieldWithReject fieldKey="city"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"City"}
                    name={"city"}
                    placeholder={"Select city"}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("city")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("address")}>
                  {/* <FieldWithReject fieldKey="address"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Lab Full Address"}
                    name={"address"}
                    placeholder={"Enter enter lab full address"}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("address")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("map_link")}>
                  {/* <FieldWithReject fieldKey="map_link"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Google Map"}
                    name={"map_link"}
                    placeholder={"Enter google map link"}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("map_link")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("person_name")}>
                  {/* <FieldWithReject fieldKey="person_name">         */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Contact Person"}
                    name={"person_name"}
                    placeholder={"Enter contact person name"}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("person_name")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("contact_number")}>
                  {/* <FieldWithReject fieldKey="contact_number">         */}
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Contact Number"}
                    name={"contact_number"}
                    placeholder={"Enter contact number"}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("contact_number")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("mobile")}>
                  {/* <FieldWithReject fieldKey="mobile">         */}
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Mobile Number"}
                    name={"mobile"}
                    placeholder={"Enter mobile number"}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("mobile")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("alt_contact_number")}>
                  {/* <FieldWithReject fieldKey="alt_contact_number">         */}
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Alternate Contact Number"}
                    name={"alt_contact_number"}
                    placeholder={"Enter alter contact number"}
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("alt_contact_number")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("email")}>
                  {/* <FieldWithReject fieldKey="email"> */}
                  <MyEmail
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Email Address"
                    name="email"
                    placeholder="Enter Email Address"
                    required
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("email")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("latitude")}>
                  {/* <FieldWithReject fieldKey="latitude">      */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Latitude"}
                    name={"latitude"}
                    placeholder={"Latitude"}
                    required
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("latitude")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("longitude")}>
                  {/* <FieldWithReject fieldKey="longitude"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Longitude"}
                    name={"longitude"}
                    placeholder={"Longitude"}
                    required
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("longitude")}
                  />
                  {/* </FieldWithReject> */}
                </Col>
              </Row>

              <Row>
                <div className="d-flex gap-5 py-3 mb-3">
                  <h5>{"Accreditation & Compliance"}</h5>
                </div>

                <Col xs="12" sm="6" md="4" lg="3">
                  <div className="form-check mt-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="isNablCertified"
                      {...register("isNablCertified")}
                    />
                    <label className="form-check-label" htmlFor="isNablCertified">
                      NABL Certified
                    </label>
                  </div>
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("nablId")}>
                  {/* <FieldWithReject fieldKey="nablId"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="NABL ID"
                    name="nablId"
                    placeholder="Enter NABL ID"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("nablId")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("nabl_certificate")}>
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="nabl_certificate"
                    watch={watch}
                    trigger={trigger}
                    setImageOpen={setImageOpen}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"NABL Accreditation Certificate"}
                    errors={errors}
                    register={register}
                    image={"nabl_certificate_img"}
                    image_url={"nabl_certificate"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    validateDoc
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("nabl_certificate")}
                  />
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("otherIds")}>
                  {/* <FieldWithReject fieldKey="otherIds"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Other ID"
                    name="otherIds"
                    placeholder="Enter Other ID"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("otherIds")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("other_certificate")}>
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    setImageOpen={setImageOpen}
                    id="other_certificate"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Other Certificate"}
                    errors={errors}
                    register={register}
                    image={"other_certificate_img"}
                    image_url={"other_certificate"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    validateDoc
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("other_certificate")}
                  />
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("cmo_certificate")}>
                  <ImageUpload
                    getValues={getValues}
                    setImageOpen={setImageOpen}
                    approve={mode === "Approval"}
                    design={4}
                    id="cmo_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label="CMO Certificate"
                    errors={errors}
                    register={register}
                    image="cmo_certificate"
                    image_url="cmo_image"
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    validateDoc
                    disabled={mode === "Approval"}
                    isObjection={getObjectionProp("cmo_certificate")}
                  />
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("cmoNumber")}>
                  {/* <FieldWithReject fieldKey="cmoNumber"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="CMO Number"
                    name="cmoNumber"
                    placeholder="Enter CMO Number"
                    required
                    isObjection={getObjectionProp("cmoNumber")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("gstNumber")}>
                  {/* <FieldWithReject fieldKey="gstNumber"> */}
                  <MyGST
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="GST Number"
                    name="gstNumber"
                    placeholder="Enter gst number"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("gstNumber")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("licenseNumber")}>
                  {/* <FieldWithReject fieldKey="licenseNumber"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="License Number"
                    name="licenseNumber"
                    placeholder="Enter License Number"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("licenseNumber")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("pan")}>
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    id="pan_image"
                    setImageOpen={setImageOpen}
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"PAN Image"}
                    errors={errors}
                    register={register}
                    image={"pan"}
                    image_url={"pan_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    validateDoc
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("pan")}
                  />
                </Col>

                {fields.map((field, index) => (
                  <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName(`lab_license.${index}.certificate`, index)} key={field.id}>
                    <ImageUpload
                      getValues={getValues}
                      id={`certificate_${index}`}
                      watch={watch}
                      trigger={trigger}
                      setImageOpen={setImageOpen}
                      setError={setError}
                      clearErrors={clearErrors}
                      errors={errors}
                      register={register}
                      label={`Lab License ${index + 1}`}
                      image={`lab_license.${index}.certificate`}
                      image_url={`lab_license.${index}.certificate_url`}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      validateDoc
                      rm
                      index={index}
                      remove={remove}
                      approve={mode === "Approval" ? true : false}
                      size={2048}
                      isObjection={getObjectionProp("license_documents", index)}
                    />
                  </Col>
                ))}

                {(watch("mode") === "Add" || watch("mode") === "Edit") && (
                  <Col md="2">
                    <Button
                      style={{ marginTop: "30px" }}
                      type="button"
                      color="primary"
                      className=" "
                      id="addDegree"
                      onClick={() => {
                        append({ certificate: null, certificate_url: null });
                      }}
                    >
                      {"Add License"}
                    </Button>
                  </Col>
                )}
              </Row>

              <Row>
                <div className="d-flex gap-5 py-3 mb-3">
                  <h5>{"Service & Catalog"}</h5>
                </div>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("service")}>
                  {/* <FieldWithReject fieldKey="service"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Service Type"
                    name="service"
                    placeholder="Enter service type"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("service")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("startTime")}>
                  {/* <FieldWithReject fieldKey="startTime"> */}
                  <DateComponent
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Start Time"
                    name="startTime"
                    placeholder="start time"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("startTime")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("endTime")}>
                  {/* <FieldWithReject fieldKey="endTime"> */}
                  <DateComponent
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="End Time"
                    name="endTime"
                    placeholder="end time"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("endTime")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("radius")}>
                  {/* <FieldWithReject fieldKey="radius"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Service Area Radius"
                    name="radius"
                    placeholder="Enter service area radius"
                    isObjection={getObjectionProp("radius")}
                  />
                  {/* </FieldWithReject> */}
                </Col>
              </Row>

              <Row>
                <div className="d-flex gap-5 py-3 mb-3">
                  <h5>{"Bank & Documents"}</h5>
                </div>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("bankName")}>
                  {/* <FieldWithReject fieldKey="bankName"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Bank Account Holder Name"
                    name="bankName"
                    placeholder="Enter bank account holder name"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("bankName")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("accountNumber")}>
                  {/* <FieldWithReject fieldKey="accountNumber"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Account Number"
                    name="accountNumber"
                    placeholder="Enter account number"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("accountNumber")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("ifscCode")}>
                  {/* <FieldWithReject fieldKey="ifscCode"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="IFSC Code"
                    name="ifscCode"
                    placeholder="Enter ifsc number"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("ifscCode")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("upiId")}>
                  {/* <FieldWithReject fieldKey="upiId"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="UPI ID"
                    name="upiId"
                    placeholder="Enter UPI id number"
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("upiId")}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName("passbook")}>
                  <ImageUpload
                    getValues={getValues}
                    approve={mode === "Approval" ? true : false}
                    design={4}
                    setImageOpen={setImageOpen}
                    id="passbook_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Bank Passbook / Cancelled Cheque"}
                    errors={errors}
                    register={register}
                    image={"passbook"}
                    image_url={"passbook_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    validateDoc
                    disabled={mode == "Approval"}
                    isObjection={getObjectionProp("passbook")}
                  />
                </Col>

                {labFields.map((field, index) => (
                  <Col xs="12" sm="6" md="3" lg="3" className={getFieldClassName(`lab.${index}.image`, index)} key={field.id}>
                    <ImageUpload
                      getValues={getValues}
                      id={`image_${index}`}
                      watch={watch}
                      trigger={trigger}
                      setImageOpen={setImageOpen}
                      setError={setError}
                      clearErrors={clearErrors}
                      errors={errors}
                      register={register}
                      label={`Lab Image ${index + 1}`}
                      image={`lab.${index}.image`}
                      image_url={`lab.${index}.image_url`}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      rm
                      index={index}
                      remove={labRemove}
                      approve={mode === "Approval" ? true : false}
                      size={2048}
                      isObjection={getObjectionProp("lab_images", index)}
                    />
                  </Col>
                ))}

                {(watch("mode") === "Add" || watch("mode") === "Edit") && (
                  <Col md="2">
                    <Button
                      style={{ marginTop: "30px" }}
                      type="button"
                      color="primary"
                      className=" "
                      id="addDegree"
                      onClick={() => {
                        labAppend({ image: null, image_url: null });
                      }}
                    >
                      {"Add Image"}
                    </Button>
                  </Col>
                )}
              </Row>

              {mode == "Approval" && (
                <Row>
                  {data.kyc_status == "Approved" ? null : (
                    <Col xs="12" sm="12" md="12" lg="12" className="mt-2">
                      <MyTextArea
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title={"Remark"}
                        name={"remark"}
                        placeholder={"Reason for approval/rejection"}
                        required
                        cols={2}
                        row={2}
                      />
                    </Col>
                  )}
                </Row>
              )}

              {mode == "Approval" && (
                <>
                  {data.kyc_status == "Approved" ? null : (
                    <Row>
                      <div className="d-flex mt-5">
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <Button
                            color="primary"
                            size="md"
                            type="submit"
                            onClick={() => setValue("actionType", "approve")}
                            disabled={isLoading || watch("objectionKeys")?.length > 0}
                          >
                            {isLoading ? <Spinner size="sm" color="light" /> : "Approve Lab"}
                          </Button>
                          <Button
                            className="mx-2"
                            color="primary"
                            size="md"
                            type="submit"
                            onClick={() => setValue("actionType", "reject")}
                          >
                            {isLoading ? <Spinner size="sm" color="light" /> : "Decline"}
                          </Button>
                        </div>
                      </div>
                    </Row>
                  )}
                </>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
      <Modal isOpen={fieldConfirmOpen} toggle={closeFieldConfirmModal}>
        <ModalHeader toggle={closeFieldConfirmModal}>Review Field</ModalHeader>
        <ModalBody>
          Do you want to approve or reject "{fieldConfirmLabel}"?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeFieldConfirmModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => handleFieldConfirmAction("approve")}>
            Approve
          </Button>
          <Button color="danger" onClick={() => handleFieldConfirmAction("reject")}>
            Reject
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default LabDetails;